import React from 'react';
import ServiceDetailTemplate from '../Elements/ServiceDetailTemplate';

const bnrimg = require('../../images/pic2.jpg');
const productImg = require('../../images/Finanzas.png');

const ServiceDetailFinance = () => (
    <ServiceDetailTemplate
        moduleKey="finanzas"
        bnrimg={bnrimg}
        productImg={productImg}
    />
);

export default ServiceDetailFinance;
